import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})

export class AgeGroupService {
  constructor(private translate: TranslateService) {}
  // TODO: ezeknek a kezelését majd refaktorálni kellene
  choosenAgeGroup = [ {detail: '', kompakt_detail: '', /* ages: null,*/ id: '', info: '', label: ''} ];
  offerChoices = [];

  public getAgeChoicesArray(id: string = null): any {
    const HIPContract = JSON.parse(sessionStorage.getItem('HIPContract'));
    let fromAge = '';
    let fromTime = '';
    let toAge = '';

    if (HIPContract) {
      if (id === '01') {  // adult
        fromAge = HIPContract.ageOfAdultPackage.toString();
        toAge = HIPContract.hipAgeLimitType.maximumAgeLimit.toString();
      }
      if (id === '02') {  // child
        fromAge = HIPContract.hipAgeLimitType.minimumAgeLimit.toString();
        fromTime = this.translate.store.currentLang === 'en' ?
          HIPContract.hipAgeLimitType.minimumAgeLimitTpyeEnglish :
          HIPContract.hipAgeLimitType.minimumAgeLimitType;
        toAge = (HIPContract.ageOfAdultPackage - 1).toString();
      }
    }

    const adult = {
      id: '01',
      label: this.translate.instant('junctures.age.adult.title'),
      detail: this.translate.instant('junctures.age.adult.notKompakt', { fromAge, toAge }),
      kompakt_detail: this.translate.instant('junctures.age.adult.kompakt', { fromAge, toAge }),
      info: ''
    };
    const child = {
      id: '02',
      label: this.translate.instant('junctures.age.child.title'),
      detail: this.translate.instant('junctures.age.child.notKompakt', { fromAge, fromTime, toAge }),
      kompakt_detail: this.translate.instant('junctures.age.child.kompakt', { fromAge, fromTime, toAge }),
      info: ''
    };

    if (id === '01') {
      return adult;
    } else if (id === '02') {
      return child;
    }

    return [adult, child];
  }
}
